import React from "react";

import "./tabsRequestDetails.scss";

const TabsDetails = ({ items, activeKey, onTabClick }) => (
  <div className="tabs">
    {items.map((item) => (
      <div
        key={item.key}
        className={`tab ${item.key === activeKey ? "active" : ""}`}
        onClick={() => onTabClick(item.key)}
      >
        {item.label}
      </div>
    ))}
  </div>
);

export default TabsDetails;
